import gql from 'graphql-tag';

export const READ_ALL_NOTIFICATION = gql`
  query {
    getAllNotificationsByUser{
      id
      read
    }
  }
`